/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/get_agent_is_personalizing" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdAudiencesGetAgentIsPersonalizing } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetAgentIsPersonalizingResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetAgentIsPersonalizingResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetAgentIsPersonalizing = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdAudiencesGetAgentIsPersonalizing,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetAgentIsPersonalizingResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/audiences/get_agent_is_personalizing`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetAgentIsPersonalizingResult
);
